import { render, staticRenderFns } from "./BoardTable.vue?vue&type=template&id=17c03480&"
import script from "./BoardTable.vue?vue&type=script&lang=js&"
export * from "./BoardTable.vue?vue&type=script&lang=js&"
import style0 from "./BoardTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports